<template>
  <page>
    <form>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Report Type
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <message :messages="messages"></message>
                <v-layout row wrap>
                  <v-autocomplete
                    :items="pcRptTypes"
                    v-model="form.pcClmTran"
                    :label="label.pcRptType"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('form.pcClmTran')"
                    data-vv-name="form.pcClmTran"
                    :data-vv-as="label.pcRptType"
                    clearable
                  ></v-autocomplete>
                </v-layout>
              </v-card-text>
            </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-3"></v-spacer>
                    <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Date Range
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <message :messages="messages"></message>
                <v-layout row wrap>
                  <v-flex xs6 sm6>
                    <cal-picker v-model="form.tranDateFrom" :label="label.tranDateFrom" :data-vv-as="label.tranDateFrom" data-vv-name="form.tranDateFrom" :error-messages="errors.collect('form.tranDateFrom')" v-validate="doValidateTranDateFrom"></cal-picker>
                  </v-flex>
                  <v-flex xs6 sm6>
                    <cal-picker v-model="form.tranDateTo" :label="label.tranDateTo" :data-vv-as="label.tranDateTo" data-vv-name="form.tranDateTo" :error-messages="errors.collect('form.tranDateTo')" v-validate="doValidateTranDateTo"></cal-picker>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
                      <v-spacer class="mt-3"></v-spacer>
            <v-card>
              <v-expansion-panels v-model="panel3" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                  </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs6 xl2>
                            <v-text-field v-model="form.branch" :label="label.branch" :error-messages="errors.collect('form.branch')" data-vv-name="form.branch" :data-vv-as="label.branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" readonly v-validate="'required'">
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="getHelpList('branch')"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 xl2>
                            <v-text-field v-model="form.dept" :label="label.dept" :error-messages="errors.collect('form.dept')" data-vv-name="form.dept" :data-vv-as="label.dept" append-icon="mdi-magnify" @click:append="getHelpList('dept')" readonly v-validate="'required'">
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="getHelpList('dept')"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 xl2>
                            <v-radio-group v-model="form.resCatAE" row :mandatory="true">
                              <v-radio :label="label.includeResCat" value="true"></v-radio>
                              <v-radio :label="label.excludeResCat" value="false"></v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs6 xl2>
                            <v-text-field v-model="form.resCat" :label="label.resCat" :error-messages="errors.collect('form.resCat')" data-vv-name="form.resCat" :data-vv-as="label.resCat" append-icon="mdi-magnify" @click:append="getHelpList('resCat')" readonly v-validate="doValResCat">
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="getHelpList('dept')"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 xl2>
                            <v-text-field v-model="form.tranType" :label="label.tranType" :error-messages="errors.collect('form.tranType')" data-vv-name="form.tranType" :data-vv-as="label.tranType" readonly v-validate="'required'">
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="TranTypeHelpList = true" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 class="pt-3">
            <v-checkbox color="primary" :label="label.prtRunTimeParamAE" v-model="form.prtRunTimeParamAE"></v-checkbox>
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
                {{label.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
    <v-dialog v-model="HelpList" width="900px"   persistent>
      <help-list :apiURI="apiURI" :mode="mode" :param="param" :defAll="defAll" :boolRefresh="HelpList" @close="doClose" @doAssign="doAssign($event)"></help-list>
    </v-dialog>
    <v-dialog v-model="TranTypeHelpList" width="900px"   persistent>
      <tran-type-help-list :defAll="true" :param="form.tranType" :boolRefresh="TranTypeHelpList" @close="doClose" @doAssignTranType="doAssignTranType($event)"></tran-type-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import HelpList from '@/components/core/common/dialog/HelpList'
import TranTypeHelpList from '@/components/core/common/dialog/TranTypeHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      label: {
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        branch: 'Branch',
        dept: 'Department',
        includeResCat: 'Include Reserve Category',
        excludeResCat: 'Exclude Reserve Category',
        resCat: 'Reserve Category',
        tranType: 'Transaction Type',
        prtRunTimeParamAE: 'Print Runtime Parameters',
        format: 'Export Format',
        export: 'Export to',
        pcRptType: 'Report Type'
      },
      form: {
        tranDateFrom: '',
        tranDateTo: '',
        branch: 'All',
        dept: 'All',
        resCatAE: 'true',
        resCat: 'All',
        tranType: 'All',
        prtRunTimeParamAE: true,
        format: 'PDF',
        pcClmTran: 'R'
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      HelpList: false,
      mode: '',
      param: '',
      defAll: false,
      apiURI: '',
      TranTypeHelpList: false,
      panel1: [0],
      panel2: [0],
      panel3: [0],
      pcRptTypes: [
        { label: 'Released Payments', value: 'R' },
        { label: 'Unreleased Payments', value: 'U' }
      ]
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.rptMenu.claimPayment
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      this.param = ''
      this.defAll = true
      if (fieldName === 'branch') {
        this.apiURI = this.$store.state.commons.menu.getBranchList
        this.param = this.form.branch
      } else if (fieldName === 'dept') {
        this.apiURI = this.$store.state.commons.menu.getDepartmentList
        this.param = this.form.dept
      } else if (fieldName === 'resCat') {
        this.apiURI = this.$store.state.commons.menu.getClmResCatList
        this.param = this.form.resCat
      }
      this.HelpList = true
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch': this.form.branch = ''
          this.form.branch = Obj.finalSelectedItems.toString()
          break
        case 'dept': this.form.dept = ''
          this.form.dept = Obj.finalSelectedItems.toString()
          break
        case 'resCat': this.form.resCat = ''
          this.form.resCat = Obj.finalSelectedItems.toString()
          break
      }
    },
    doAssignTranType(Obj) {
      this.form.tranType = ''
      this.form.tranType = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.HelpList = false
      this.TranTypeHelpList = false
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        this.form.format = value[0].value
      }
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    doValidateTranDateFrom() {
      const today = new Date()
      if (this.form.pcClmTran === 'U') {
        return 'valMaxDate:' + today
      }
      return 'required|valMaxDate:' + today
    },
    doValidateTranDateTo() {
      if (this.form.pcClmTran === 'U') {
        if (this.form.tranDateFrom !== null) {
          return 'valMinDate:' + this.form.tranDateFrom
        }
      }
      return 'required'
    },
    doValResCat() {
      if (this.form.resCatAE === 'false') {
        return 'required|valResCat:' + 'All'
      } else {
        return 'required'
      }
    }
  },
  created() {
    this.$validator.extend('valMaxDate', {
      getMessage(field, args) {
        return 'Cannot be later than System Date'
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinDate', {
      getMessage(field, args) {
        return 'Cannot be earlier than From Date'
      },
      validate(value, args) {
        let mixDate = args[0]
        if (value) {
          return !isAfter(removeTime(mixDate), removeTime(value))
        } else return true
      }
    })
    this.$validator.extend('valResCat', {
      getMessage(field, args) {
        return 'All is not allowed if Exclude Reserve Category is selected'
      },
      validate(value, args) {
        let resCat = args[0]
        if (value === resCat) {
          return false
        } else return true
      }
    })
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    HelpList,
    TranTypeHelpList
  }
}

</script>
